import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthLayout } from "../components/auth/AuthLayout";
import { ResetPasswordForm } from "../components/auth/ResetPasswordForm";
import { useAuthStore } from "../store/authStore";

export const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { approveFromWaitlist, clearRecoverySession } = useAuthStore();

  const isInvite = searchParams.get("flow") === "invite";

  const title = isInvite ? "Welcome! Set your password" : "Set new password";
  const subtitle = isInvite
    ? "Create a password to get started"
    : "Enter your new password below";

  const handleSuccess = async () => {
    if (isInvite) {
      try {
        await approveFromWaitlist();
      } catch (error) {
        console.error("Failed to approve from waitlist:", error);
      }
      navigate("/onboarding/complete-profile", { replace: true });
    } else {
      clearRecoverySession();
      navigate("/", { replace: true });
    }
  };

  return (
    <AuthLayout title={title} subtitle={subtitle}>
      <ResetPasswordForm onSuccess={handleSuccess} />
    </AuthLayout>
  );
};
